import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import {
    IFilterParams,
    IPackage,
    IPackagesList,
    ISelectWithTotal,
    ITariff,
    ITariffPackageInstance,
    ITariffPackageInstanceCardItem,
    ITariffPackagesToBuyItem,
    ITariffPackagesToBuyListItem,
    ITariffToBuyItem,
    ITariffToBuyListItem,
    ITariffsList,
} from '../../interfaces';

export function useTariffsList(): ITariffsList {
    return useContext(MobXProviderContext).RootStore.tariffsStore.list;
}

export function useTariffsPackages(): IPackagesList {
    return useContext(MobXProviderContext).RootStore.tariffsStore.packagesList;
}

export function useTariff(): ITariff {
    return useContext(MobXProviderContext).RootStore.tariffsStore.tariff;
}

export function useTariffPackage(): IPackage {
    return useContext(MobXProviderContext).RootStore.tariffsStore.packageItem;
}

export function useTariffPackageInstanceList(): ITariffPackageInstance[] {
    return useContext(MobXProviderContext).RootStore.tariffsStore.packageInstanceItemList;
}
export function useTariffPackageInstanceItem(): ITariffPackageInstance {
    return useContext(MobXProviderContext).RootStore.tariffsStore.packageInstanceItem;
}
export function useTariffPackageInstanceCardList(): ITariffPackageInstanceCardItem[] {
    return useContext(MobXProviderContext).RootStore.tariffsStore.packageInstanceCardList;
}
export function useTariffPackageInstanceCardListInfo(): { allCount: number; pageNumber: number; pageSize: number } {
    const allCount = useContext(MobXProviderContext).RootStore.tariffsStore.packageInstanceCardListAllCount;
    const pageNumber = useContext(MobXProviderContext).RootStore.tariffsStore.packageInstanceCardListPage;
    const pageSize = useContext(MobXProviderContext).RootStore.tariffsStore.packageInstanceCardListPageSize;
    return { allCount, pageNumber, pageSize };
}

export function useTariffsFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.tariffsStore.filterParams;
}

export function useTariffsSelectWithTotal(): ISelectWithTotal {
    const select = useContext(MobXProviderContext).RootStore.tariffsStore.select;
    const total = useContext(MobXProviderContext).RootStore.tariffsStore.totalSelect;
    return {
        select,
        total,
    };
}

export function useTariffPackagesSelectWithTotal(): ISelectWithTotal {
    const select = useContext(MobXProviderContext).RootStore.tariffsStore.tariffsPackageSelect;
    const total = useContext(MobXProviderContext).RootStore.tariffsStore.tariffsPackageTotal;
    return {
        select,
        total,
    };
}
// ------------ TariffToBuyList ------------
export function useTariffsToBuyFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.tariffsStore.filterToBuyParams;
}
export function useTariffsToBuyList(): ITariffToBuyListItem[] {
    return useContext(MobXProviderContext).RootStore.tariffsStore.tariffsToBuyList;
}
export function useTariffsToBuyItem(): ITariffToBuyItem {
    return useContext(MobXProviderContext).RootStore.tariffsStore.tariffsToBuyItem;
}
// ------------ TariffToBuyList ------------
export function useTariffsPackagesToBuyFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.tariffsStore.filterParamsPackagesToBuy;
}
export function useTariffsPackagesToBuyList(): ITariffPackagesToBuyListItem[] {
    return useContext(MobXProviderContext).RootStore.tariffsStore.listPackagesToBuy;
}

export function useTariffsPackagesToBuyItem(): ITariffPackagesToBuyItem {
    return useContext(MobXProviderContext).RootStore.tariffsStore.tariffsPackagesToBuyItem;
}
